import { ShieldCheck, Award, UserCheck, MapPin } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, text: "In Business Since 1980" },
  { icon: Award, text: "46+ Years of Trust" },
  { icon: UserCheck, text: "Owner Verifies Every Job" },
  { icon: MapPin, text: "NorCal & Greater LA" },
  { icon: ShieldCheck, text: "Warranties Beyond Industry Standard" },
  { icon: Award, text: "HOA, Casino, Residential" },
];

export const TrustBar = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="trust-bar" className="bg-slate-900 border-y border-white/5 py-4 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center gap-2.5 px-8 shrink-0">
            <item.icon className="h-5 w-5 text-red-600" />
            <span className="text-white/90 font-semibold text-sm whitespace-nowrap uppercase tracking-wide">
              {item.text}
            </span>
            <span className="text-red-600/40 pl-8">•</span>
          </div>
        ))}
      </div>
    </section>
  );
};
